module.exports = __webpack_public_path__ + "img/vip.071892f9.png";